import { Link, Outlet } from 'react-router-dom';
import { useSession } from '../lib/session';

/**
 * Chrome for the public parcel doors (Run 6). No RequireAuth: the seat URL is
 * the credential, so this shell must render for a visitor with no session at
 * all. Signed-in customers get a link back to their bearer surfaces; nobody
 * gets jobs/wallet/team nav here.
 */
export default function DoorShell() {
  const { contractor } = useSession();
  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <header className="sticky top-0 z-10 flex items-center justify-between gap-4 border-b border-border bg-bg/90 px-4 py-4 backdrop-blur md:px-8">
        <div>
          <p className="text-lg font-extrabold tracking-tight text-ink">
            Lien<span className="text-tint">Guardian</span>
          </p>
          <p className="text-xs text-dim">Your parcel file</p>
        </div>
        {contractor && <Link to="/parcels" className="text-sm text-muted">My parcel files</Link>}
      </header>
      <main className="mx-auto w-full max-w-4xl min-w-0 flex-1 px-4 py-6 md:px-8">
        <Outlet />
      </main>
    </div>
  );
}
